import { render, staticRenderFns } from "./ColumnAssignedTo.vue?vue&type=template&id=6c141855&"
import script from "./ColumnAssignedTo.vue?vue&type=script&lang=ts&"
export * from "./ColumnAssignedTo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports